export { metsamaterjal, getFerry };

let info_mapinitialize, setFerry, getFerry, addMarker, mapinitialize, mapCustomDisabled, findCleanDestination, mapCustomEnabled, calcRoute, show_hide_ferry, refresh_kulu, changeKlausel, selectKoht, toFixed, refresh_teemaks;

const metsamaterjal = () => {
    var val;
    if (MODULE_NAME === "metsamaterjal") {
        $("#puidusortiment").on("change", function () {
            val = $(this).val();
    
            var puidusortiment = parseInt(val);
            if (isNaN(puidusortiment)) {
                puidusortiment = 0;
            }
            // t=4&a=aktiivsed&f=metsamaterjal
    
            document.location = metsamaterjalPuidusortimentLinkIt + puidusortiment;
        });
        if (typeof metsamaterjalLat !== "undefined" && typeof metsamaterjalLng !== "undefined") {
            var info_origin = new google.maps.LatLng(metsamaterjalLat, metsamaterjalLng);
    
            info_mapinitialize = function() {
                var myOptions = {
                    zoom: 9,
                    center: info_origin,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: true
                }
                info_map = new google.maps.Map(document.getElementById("map_canvas_info"), myOptions);
                var marker = new google.maps.Marker({
                    position: info_origin,
                    map: info_map,
                    title: "Oksjoniobjekti asukoht"
                });
            }
    
            window.addEventListener("load", info_mapinitialize);
        }
        if (typeof metsamaterjalSetAuctionLink !== "undefined") {
            MO.setAuctionLink(metsamaterjalSetAuctionLink);
        }
        if (typeof rendererOptions !== 'undefined') {
            var directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions);
            var directionsService = new google.maps.DirectionsService();
            var eesti = new google.maps.LatLng(metsamaterjalEestiLat, metsamaterjalEestiLng);
            var origin = new google.maps.LatLng(metsamaterjalOriginLat, metsamaterjalOriginLng);
    
            setFerry = function(val) {
                ylevedu = val;
                $("#ylevedu").val(val);
            }
    
            getFerry = function() {
                return ylevedu;
            }
    
            // Add a marker to the map and push to the array.
            addMarker = function(location, draggable, title) {
                var _m = new google.maps.Marker({
                    position: location,
                    map: map,
                    draggable: draggable,
                    title: title
                });
                map_markers.push(_m);
                return _m;
            }
    
            mapinitialize = function() {
                //log("mapinitialize() readonly", readonly);
                //console.log("mapinitialize() readonly", readonly);
                if (!readonly) {
                    $("#set-route").show();
                }
                var myOptions = {
                    zoom: 6,
                    center: eesti,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: true
                }
                map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
                if (!readonly) {
                    directionsDisplay.setMap(map);
                    google.maps.event.addListener(directionsDisplay, "directions_changed", function () {
                        computeTotalDistance(directionsDisplay.directions);
                    });
                }
                //log("mapinitialize", "enableManualPointer:", enableManualPointer);
                if (enableManualPointer) {
                    mapCustomEnabled();
                }
    
                marker = addMarker(origin, false, metsamaterjalMarkerTxt);
                var lat = $("#latitude").val();
                var long = $("#longitude").val();
                destination = new google.maps.LatLng(lat, long);
                calcRoute();
                if (readonly) {
                    var pathCoordinates = [];
                    for (var i = 0; i < route_path.length; i++) {
                        //log(route_path[i]);
                        //pathCoordinates.push(new google.maps.LatLng(route_path[i].d, route_path[i].e));
                        pathCoordinates.push(new google.maps.LatLng(route_path[i].lat, route_path[i].lng));
                    }
                    if (pathCoordinates.length) {
                        //log(pathCoordinates);
                        var routePath = new google.maps.Polyline({
                            path: pathCoordinates,
                            geodesic: true,
                            strokeColor: "#55A7D4",
                            strokeOpacity: 0.7,
                            strokeWeight: 5
                        });
                        routePath.setMap(map);
                    } else {
                        console.log("pathCoordinates is empty");
    
                        //var directionsService = new google.maps.DirectionsService();
                        //    directionsService
    
                        var directionsDisplayi = new google.maps.DirectionsRenderer({
                            draggable: false,
                            suppressMarkers: true
                        });
                        directionsDisplayi.setMap(map);
                        directionsService.route({
                            origin: origin,
                            destination: destination,
                            travelMode: google.maps.TravelMode.DRIVING
                        }, function (response, status) {
                            directionsDisplayi.setDirections(response);
                        });
    
    
                    }
                } else {
                    $("#reset-route").show().on("click", function () {
                        findCleanDestination(destination);
                        return false;
                    });
                }
            }
    
            mapCustomDisabled = function() {
                customEn = 0;
                google.maps.event.clearListeners(map, "click");
    
                if (destination_marker != null && typeof destination_marker === "object" && "setDraggable" in destination_marker) {
                    destination_marker.setDraggable(false);
                }
            }
    
            findCleanDestination = function(destination) {
                directionsService.route({
                    origin: destination,
                    destination: destination,
                    travelMode: google.maps.DirectionsTravelMode.DRIVING
                }, function (response, status) {
                    if (status == google.maps.DirectionsStatus.OK) {
                        destination = response.routes[0].legs[0].start_location;
                    }
                    $("#latitude").val(destination.lat());
                    $("#longitude").val(destination.lng());
                    calcRoute(destination);
                });
            }
    
            mapCustomEnabled = function() {
                if (!customEn) {
                    customEn = 1;
                    google.maps.event.addListener(map, "click", function (event) {
                        //log("enableManualPointer", enableManualPointer);
                        destination = event.latLng;
                        findCleanDestination(destination);
                    });
                    if (destination_marker != null && typeof destination_marker === "object" && "setDraggable" in destination_marker) {
                        destination_marker.setDraggable(true);
                    }
                }
            }
    
            calcRoute = function(dest) {
                console.log("calcRoute #1", dest);
    
                if (dest === false) {
                    //directionsDisplay.setDirections({routes: []});
                } else {
                    if (!dest) {
                        dest = destination;
                    }
    
                    if (destination_marker != null && typeof destination_marker === "object" && "setPosition" in destination_marker) {
                        destination_marker.setPosition(dest);
                    } else {
                        destination_marker = addMarker(dest, !readonly, "X");
                        //destination_marker.setIcon("http://maps.google.com/mapfiles/ms/icons/green-dot.png");
                        destination_marker.setIcon("https://www.google.com/mapfiles/marker_green.png");
                        if (!readonly) {
                            google.maps.event.addListener(destination_marker, "dragend", function (event) {
                                //geocodePosition(marker.getPosition());
                                destination = destination_marker.getPosition();
                                findCleanDestination(destination);
                            });
                        }
                    }
                    if (!readonly) {
                        var request = {
                            origin: origin,
                            destination: dest,
                            waypoints: [{
                                location: origin
                            }, {
                                location: dest
                            }],
                            travelMode: google.maps.DirectionsTravelMode.DRIVING
                        };
                        directionsService.route(request, function (response, status) {
                            if (status == google.maps.DirectionsStatus.OK) {
                                directionsDisplay.setDirections(response);
                                //console.log(response);
                            }
                        });
                    }
                }
            }
    
            var is_latvia = 0;
    
            function computeTotalDistance(result) {
                var total = 0;
                var total_land = 0;
                var distval = 0;
                var steps, step, path;
                var myroute = result.routes[0];
                var n1;
                var n2;
                var list = new Array();
                //console.log(myroute);
                //log(myroute);
                is_latvia = 0;
                setFerry(0);
                if (myroute) {
                    for (var i = 0; i < myroute.legs.length; i++) {
                        steps = myroute.legs[i].steps;
                        distval = myroute.legs[i].distance.value;
                        total += distval;
                        for (var s = 0; s < steps.length; s++) {
                            step = steps[s];
                            //console.log("maneuver", step.maneuver, "distance", step.distance.text);
    
                            n1 = step.instructions.indexOf("Entering Latvia");
                            n2 = step.instructions.indexOf("Sisenemine riiki: Läti");
                            console.log(s, step.instructions);
                            list.push(step);
                            if (n1 > 1 || n2 > 1) {
                                is_latvia = 1;
                            }
                            if (step.maneuver != "ferry") {
                                total_land += step.distance.value;
                            } else {
                                log("Ferry", (step.distance.value / 1000), "km");
                                setFerry(1);
                            }
                        }
                    }
                    total = total / 1000;
                    total_land = total_land / 1000;
    
                    path = myroute.overview_path;
                    //log(path);
                    path = JSON.stringify(path);
                    //log("" + path);
                    //document.write(path);
                }
                console.log(list);
                if (is_latvia) {
                    $("#teemaks-row").show();
                } else {
                    $("#teemaks-row").hide();
                }
                if (!readonly) {
                    document.getElementById("kaugus_kokku").innerHTML = total + " km";
                    document.getElementById("kaugus_kokku_land").innerHTML = total_land + " km";
                    document.getElementById("kaugus").value = total;
                    document.getElementById("kaugus_land").value = total_land;
                    document.getElementById("overview_path").value = path;
                    document.getElementById("is_latvia").value = is_latvia;
    
                    console.log("refresh_teemaks()");
                    refresh_teemaks();
                }
                refresh_kulu();
            }
    
            show_hide_ferry = function() {
                var total = 0;
                $(".muu-kulu-ylevedu").each(function () {
                    var $o = $(this);
                    if (ylevedu) {
                        $o.find("input").prop("disabled", false);
                    } else {
                        $o.find("input").prop("disabled", true);
                    }
                    total++;
                });
                return total;
            }
    
            refresh_kulu = function() {
                var tarnekoht;
                if (!readonly) {
                    var total = show_hide_ferry();
                    if (ylevedu && !total) {
                        MO.warning(warning_ylevedu_vajalik);
                        return;
                    }
                }
                var tarneklausel = document.getElementById("tarneklausel").value;
                var kaugus = document.getElementById("kaugus").value;
                var kaugus_land = document.getElementById("kaugus_land").value;
                var overview_path = document.getElementById("overview_path").value;
                var kogus = document.getElementById("kogus").value;
    
                if (readonly) {
                    tarnekoht = $("#tarnekoht").val();
                } else {
                    if (tarneklausel == "DAT" || tarneklausel == "") {
                        tarnekoht = $("select", $("#tarnekoht-DAT")).val();
                    } else if (tarneklausel == "DAP") {
                        tarnekoht = $("select", $("#tarnekoht-DAP")).val();
                    } else {
                        tarnekoht = $("select", $("#tarnekoht-FOB")).val();
                    }
                }
                // + "&overview_path=" + overview_path
                var extra = "&tarneklausel=" + tarneklausel + "&tarnekoht=" + tarnekoht + "&kaugus=" + kaugus + "&kogus=" + kogus + "&kaugus_land=" + kaugus_land + "&is_latvia=" + is_latvia;
                //log("tarneklausel", tarneklausel);
                //log("tarnekoht", tarnekoht);
                //log("kaugus", kaugus);
                //log("kaugus_land", kaugus_land);
                $.ajax({
                    url: auction_link + extra,
                    success: function (data) {
    
                    }
                });
            }
    
            window.addEventListener("load", mapinitialize);
        }
        if (typeof elapsed_interval !== "undefined") {
            elapsed_interval = setInterval(function () {
                elapsed_seconds = elapsed_seconds - 1;
                var res = get_elapsed_time_string(elapsed_seconds);
                if (res === false) {
                    $(".timer").hide();
                    clearInterval(elapsed_interval);
                } else {
                    $(".timer").html(res);
                }
            }, 1000);
        }
        if (typeof readonly !== "undefined") {
            changeKlausel = function(act, init) {
                if (act == "NONE") {
                    $("#tarnekoht-FOB").hide();
                    $("#tarnekoht-DAT").hide();
                    $("#tarnekoht-DAP").hide();
                    $("#tarnekoht-NONE").show();
                    val = $("select", $("#tarnekoht-NONE")).val();
                } else if (act == "DAT" || act == "" || act === undefined) {
                    $("#tarnekoht-FOB").hide();
                    $("#tarnekoht-DAT").show();
                    $("#tarnekoht-DAP").hide();
                    $("#tarnekoht-NONE").hide();
                    val = $("select", $("#tarnekoht-DAT")).val();
                } else if (act == "DAP") {
                    $("#tarnekoht-FOB").hide();
                    $("#tarnekoht-DAT").hide();
                    $("#tarnekoht-DAP").show();
                    $("#tarnekoht-NONE").hide();
                    val = $("select", $("#tarnekoht-DAP")).val();
                } else {
                    $("#tarnekoht-DAT").hide();
                    $("#tarnekoht-FOB").show();
                    $("#tarnekoht-DAP").hide();
                    $("#tarnekoht-NONE").hide();
                    val = $("select", $("#tarnekoht-FOB")).val();
                }
                selectKoht(val, init);
            }
    
            selectKoht = function(val, init) {
                var latlng;
                var pieces;
                console.log("selectKoht", val, init);
    
                if (val == "0") {
                    if (!$("#latitude").is("[readonly]")) {
                        $("#latitude").val("");
                        $("#longitude").val("");
                    }
                    if (init) {
                        enableManualPointer = 1;
                    } else {
                        mapCustomEnabled();
                    }
                    calcRoute(false);
                } else {
                    if (init) {
                        enableManualPointer = 0;
                    } else {
                        mapCustomDisabled();
                    }
                    latlng = $("#incoterm_latlng_" + val).val();
                    pieces = latlng.split(",");
                    $("#latitude").val(pieces[0]);
                    $("#longitude").val(pieces[1]);
    
                    destination = new google.maps.LatLng(pieces[0], pieces[1]);
                    calcRoute(destination);
                }
                log("selectKoht", "init:", init, "val", val, "enableManualPointer:", enableManualPointer);
            }
    
            if (!readonly) {
    
                $("#tarneklausel").change(function () {
                    changeKlausel($(this).val());
                });
                changeKlausel($("#tarneklausel").val(), 1);
    
                $("select", $("#tarnekoht-DAT")).change(function () {
                    selectKoht($(this).val());
                });
                $("select", $("#tarnekoht-DAP")).change(function () {
                    selectKoht($(this).val());
                });
                $("select", $("#tarnekoht-FOB")).change(function () {
                    selectKoht($(this).val());
                });
                $("select", $("#tarnekoht-NONE")).change(function () {
                    selectKoht($(this).val());
                });
                $("#kogus").on("keyup", function () {
                    refresh_teemaks();
                });
    
            }
    
            toFixed = function(value, precision) {
                var precision = precision || 0,
                    power = Math.pow(10, precision),
                    absValue = Math.abs(Math.round(value * power)),
                    result = (value < 0 ? "-" : "") + String(Math.floor(absValue / power));
    
                if (precision > 0) {
                    var fraction = String(absValue % power),
                        padding = new Array(Math.max(precision - fraction.length, 0) + 1).join("0");
                    result += "." + padding + fraction;
                }
                return result;
            }
    
            refresh_teemaks = function() {
                is_latvia = parseInt($("#is_latvia").val());
                var kogus = parseInt($("#kogus").val());
                var kaugus = parseInt($("#kaugus").val());
                var arvestslik_kuu = 30;
                if (kaugus > 0 && kogus > 0 && is_latvia == 1) {
                    var koormaga_kokku = (kogus / teemaks_m3_koorem) * kaugus;
                    var vajadus_koormaga_km_paeavas = koormaga_kokku / tarne_days;
                    var arvestuslik_km_paeavas = teemaks_labisoit_kuus / arvestslik_kuu;
                    var vajalik_autode_arv = Math.ceil(vajadus_koormaga_km_paeavas / arvestuslik_km_paeavas);
                    var tarneperioodi_teemaks_sumaarselt = toFixed((teemaks_tariif_kuu / arvestslik_kuu) * tarne_days * vajalik_autode_arv, 2); // ( 75 / 30 ) * 0 * Infinity
                    var teemaks_tm_kohta = toFixed(tarneperioodi_teemaks_sumaarselt / kogus, 2);
    
    
                    console.log("kogus", kogus);
                    console.log("kaugus", kaugus);
                    console.log("days", tarne_days);
                    console.log("m3_koorem", teemaks_m3_koorem);
                    console.log("labisoit_kuus", teemaks_labisoit_kuus);
                    console.log("tariif_kuu", teemaks_tariif_kuu);
                    console.log("arvestslik_kuu", arvestslik_kuu);
                    console.log("koormaga_kokku", koormaga_kokku);
                    console.log("vajadus_koormaga_km_paeavas", vajadus_koormaga_km_paeavas);
                    console.log("arvestuslik_km_paeavas", arvestuslik_km_paeavas);
                    console.log("vajalik_autode_arv", vajalik_autode_arv);
                    console.log("tarneperioodi_teemaks_sumaarselt", tarneperioodi_teemaks_sumaarselt);
                    console.log("teemaks_tm_kohta", teemaks_tm_kohta);
    
                    $("#teemaks-row-price").html(teemaks_tm_kohta);
                    $("#price_teemaks").val(teemaks_tm_kohta);
                } else {
                    $("#teemaks-row-price").html("&nbsp;");
                    $("#price_teemaks").val(0);
                }
                MO.calcKuluTotal();
            }
        }
    }
}